var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DropdownMenuItemBase',{attrs:{"icon":_vm.state.isLoading ? 'loading' : _vm.isAdded ? 'check' : 'inactiveFolder',"text":_vm.project.name},on:{"click":function($event){return _vm.toggle()}}})}
var staticRenderFns = []

export { render, staticRenderFns }